import React, { useEffect, useRef } from 'react';
import { useQuery } from '@apollo/react-hooks';
import { Link } from 'react-router-dom';
import { slugify } from 'helpers/text';
import { compose } from 'helpers/fp';
import { get } from 'helpers/utilities';
import { jobLocationQuery } from 'queries/jobBenefits';

import styles from './styles.scss';

const getLocationHeaderImageURL = data =>
  get(data, 'entry.locationHeader[0].headerBackground[0].url');
const filterGrayscale = url =>
  url ? `${url}?auto=format&fit=crop&sat=-100&invert=false&bri=0` : url;

const locationHeaderImage = compose(filterGrayscale, getLocationHeaderImageURL);

const JobDetailCTA = ({ locationCTA, className }) => {
  const { loading, error, data = {} } = useQuery(jobLocationQuery(slugify(locationCTA)));
  const jobCTARef = useRef();

  const { entry } = data;

  useEffect(() => {
    const jobCTAFocusListener = () => {
      const ctaRect = jobCTARef.current.getBoundingClientRect();
      const currentScrollY = window.scrollY || window.pageYOffset;

      if (currentScrollY > ctaRect.height + ctaRect.top) {
        window.scrollTo(0, 1);
      }
    };

    if (jobCTARef.current) {
      jobCTARef.current.addEventListener('focus', jobCTAFocusListener);
      return () => jobCTARef.current.removeEventListener('focus', jobCTAFocusListener);
    }
  }, []);

  if (loading || error) return null;

  return entry ? (
    <Link
      ref={jobCTARef}
      title={`Discover The ${locationCTA} Office`}
      className={`${styles.jobDetailCard} ${className}`}
      style={{ backgroundImage: `url("${locationHeaderImage(data)}")` }}
      to={`/location/${slugify(locationCTA)}`}>
      <p>{`Discover The ${locationCTA} Office`}</p>
    </Link>
  ) : null;
};

export default JobDetailCTA;
